import { EntityGeneration } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityGeneration';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
export class EntityGenerationExtend {
  public static Init(dto: EntityGeneration) {
    dto.relationshipType = EnumRelationshipType.EntityGeneralization;
  }
}
